import React from 'react';
import styled from '@emotion/styled';
import { Flex, Image } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import Heading from '@/components/Heading';
import Link from '@/components/Link';
import getAsset from '@/utils/getAsset';

const StyledFlex = styled(Flex)`
  border-radius: ${themeGet('radii.md')};
  background-color: ${themeGet('colors.background.banner')};
`;

const QantasFrequentFlyerBanner = React.memo(() => (
  <StyledFlex
    p={4}
    flexDirection={['column', null, 'row']}
    alignItems={[null, null, 'center']}
  >
    <Flex mb={['4', null, 'unset']} alignItems="center">
      <Image
        src={getAsset('/images/icons/ic_qff.svg')}
        alt="Qantas icon"
        width="50px"
      />
      <Heading.h5 px={['2', null, '4']}>
        Not a Qantas Frequent Flyer member?
      </Heading.h5>
    </Flex>
    <Link.QantasButton
      href="https://www.qantas.com/au/en/frequent-flyer/discover-and-join/join-now.html/code/jetstar?alt_cam=n:n:n:jqholidays:banner:joinforfree:n:n:n:n"
      target="_blank"
      outline
      ml={[null, null, 'auto']}
    >
      Join for free
    </Link.QantasButton>
  </StyledFlex>
));

export default QantasFrequentFlyerBanner;
